// The web app version number.
export const appVersion="1.0.0";